module.exports = __webpack_public_path__ + "assets/41be97e62886fe4c1041f4beafbbb3b1.png";